import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type FinancialOrderInformationForCustomerEventId = Branded<
    string,
    "FinancialOrderInformationForCustomerEventId"
>;
const financialOrderInformationForCustomerEventIdPrefix =
    "financial_order_history_for_customer_event__";
const {
    factory: financialOrderInformationForCustomerEventIdFactory,
    assert: isFinancialOrderInformationForCustomerEventId,
    zodSchema: financialOrderInformationForCustomerEventIdZodSchema,
} = genericId<FinancialOrderInformationForCustomerEventId>(
    financialOrderInformationForCustomerEventIdPrefix,
);

export {
    financialOrderInformationForCustomerEventIdFactory,
    financialOrderInformationForCustomerEventIdPrefix,
    financialOrderInformationForCustomerEventIdZodSchema,
    isFinancialOrderInformationForCustomerEventId,
};
export type { FinancialOrderInformationForCustomerEventId };
